<!-- Rules Screen has
        * introductory page  [no panel]
        * tutorial

    Rules view has
        * section on Pentelion rules  [panel has table of contents]
        * overview of all powers  [panel has navigation structure with domains]
 -->

<main>
	<LoginPanel />
	<section>
        <h1>Features</h1>

        <h2>V 2.76: Improved character management</h2>
        <h3>Server:</h3>
        <ul>
            <li>Cleaned up character management (in server.py and chars.py)</li>
            <li>Equipment object managing all items and equipped states</li>
            <li>Stored objects being automatically created from database</li>
            <li>Character data is now shifted instead of scaled</li>
        </ul>
        <h3>Client:</h3>
        <ul>
            <li>Hero sheets are revived (Traits and overview are working)</li>
            <li>Upload multiple images</li>
            <li>Timeline is sent as list and not as dict (order is kept)</li>
            <li>Hints are now displayed on bottom right side</li>
        </ul>

        <h2>V 2.75: Adventure sections</h2>
        <h3>Server:</h3>
        <ul>
            <li>Adventure has a number of prepared sections (story, scene, travel)</li>
            <li>Stored objects have automatic connection to database</li>
            <li>Adventure and game can be created by the app</li>
            <li>Communication with client also in preparation mode</li>
            <li>Each playing session is recorded with its players and played sections</li>
        </ul>
        <h3>Client:</h3>
        <ul>
            <li>New adventure overview screen (showing sections)</li>
            <li>All adventure related information in thisAdvent (--&gt; automatic screen updating)</li>
            <li>Adventure / sections can be started via button in adventure view</li>
            <li>Images can be accessed via Adventure overview (renaming possible)</li>
            <li>Particpations on Adventure overview, separated from character definition</li>
            <li>Characters are loaded asynchronous</li>
            <li>Selection is now indicated via highlighting</li>
        </ul>

        <h2>V 2.74: Scenes revised</h2>
        <h3>Server:</h3>
        <ul>
            <li>IDs of infos differentiated by info type</li>
            <li>cleanup of scenes started</li>
        </ul>
	</section>
</main>

<script>
    import LoginPanel from "../panels/LoginPanel.svelte";
</script>

<style>

    h1 {
        text-align: left;
        margin-top: 100px;
        margin-bottom: 50px;
	}

    h2 {
        border-top:solid 1px rgba(255,255,255,0.8);
        padding: 20px 20px;
	}

    h3, ul li {
        margin-left: 20px;
	}

    ul {
        padding-bottom: 30px;
	}

    section {
        margin-left: 375px;
	}
</style>